import Vue from "vue";
import Vuex from "vuex"
import App from "./App.vue";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";


Vue.config.productionTip = false;


Vue.use(Vuex);

const store = new Vuex.Store(
    {
        state: {
            authenticated: false
        },
        mutations: {
            setAuthentication(state, status) {
                state.authenticated = status;
            }
        }
    }
);

import makeRouter from "./router";
let router = makeRouter(store);



new Vue({
  router,
  vuetify,
  store: store,
  render: h => h(App)
}).$mount("#app");
